import React from "react";
import ReactLoading from "react-loading";

/**
 * SearchPlateModal — Araç plaka arama modalı
 * NavbarMenu'dan çıkartıldı.
 */
const SearchPlateModal = ({
  show,
  onClose,
  onInputChange,
  onSubmit,
  onButtonClick,
  onFileChange,
  fileInputRef,
  plateFindloading,
}) => {
  return (
    <div className={show ? "modal fade show" : "modal fade"} role="dialog">
      <div className="modal-dialog" role="document">
        <div className="modal-content" id="searchPlateModelContent">
          <div className="modal-header">
            <h4 className="title" id="searchPlate">Araç Bul</h4>
          </div>
          <div className="modal-body">
            <p className="text-center mt-2 mb-2">
              Aşağıdaki kamera butonuna tıklayıp bir araç fotoğrafı çekerek veya yükleyerek araç formuna ulaşabilirsiniz!
              <small className="text-danger"> (Araç fotoğrafında Plakanın göründüğünden emin olunuz!)</small>
            </p>
            <div className="form-group d-flex justify-content-center">
              <button
                type="button"
                className="btn btn-outline-info mb-2 mt-2"
                style={{ fontSize: "xxx-large" }}
                onClick={onButtonClick}
              >
                <i className="fa fa-camera"></i>
              </button>
              <input
                type="file"
                ref={fileInputRef}
                style={{ display: 'none' }}
                onChange={onFileChange}
              />
            </div>
            <div className="form-group">
              <div className="form-line">
                <p className="text-center mt-2 mb-2">veya plaka giriniz</p>
                <input
                  name="plate"
                  type="text"
                  className="form-control"
                  placeholder="Plaka Giriniz"
                  onChange={onInputChange}
                />
              </div>
            </div>
          </div>
          <div className="modal-footer">
            {plateFindloading ? (
              <button className="btn btn-outline-primary btn-lg" disabled={true} style={{ textAlign: "-webkit-center" }}>
                Lütfen Bekleyin...
                <ReactLoading type="spin" width={'24px'} height={'24px'} color="#268bd2" />
              </button>
            ) : (
              <button type="button" className="btn btn-outline-primary" onClick={onSubmit}>Ara</button>
            )}
            <button type="button" onClick={onClose} className="btn btn-simple" data-dismiss="modal">Kapat</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchPlateModal;
